custom.clickEvent = function(){

  $('#qa-form-wrapper .body-type-quiz input:radio').change(function () {
    $("#qa-form-wrapper .body-type-quiz .button-wrap .next .button").removeClass("disabled");
  });

  $('#qa-form-wrapper .skin-type-quiz input:radio').change(function () {
    $("#qa-form-wrapper .skin-type-quiz .button-wrap .next .button").removeClass("disabled");
  });

  $('#qa-form-wrapper .mental-and-motional-quiz input:radio').change(function () {
    $("#qa-form-wrapper .mental-and-motional-quiz .button-wrap .next .button").removeClass("disabled");
  });

  // next button click event
	$(document).on("click", ".body-type-quiz .button-wrap .next .btn",function(){
		$(".body-type-quiz").hide();
		$(".skin-type-quiz").show();
		$(".tabbed_text[data-value='body-type']").removeClass("active");
		$(".tabbed_text[data-value='skin-type']").addClass("active");
	});
	$(document).on("click", ".skin-type-quiz .button-wrap .next .btn",function(){
		$(".skin-type-quiz").hide();
		$(".mental-and-motional-quiz").show();
		$(".tabbed_text[data-value='skin-type']").removeClass("active");
		$(".tabbed_text[data-value='emotional-mental-state']").addClass("active");
	})

	// previous button click event
	$(document).on("click", ".skin-type-quiz .button-wrap .previous .btn",function(){
		$(".body-type-quiz").show();
		$(".skin-type-quiz").hide();
		$(".tabbed_text[data-value='body-type']").addClass("active");
		$(".tabbed_text[data-value='skin-type']").removeClass("active");
	});

	// check radio button 
	$(document).on("click", ".mental-and-motional-quiz .button-wrap .previous .btn",function(){
		$(".skin-type-quiz").show();
		$(".mental-and-motional-quiz").hide();
		$(".tabbed_text[data-value='skin-type']").addClass("active");
		$(".tabbed_text[data-value='emotional-mental-state']").removeClass("active");
	});

  $(document).on("click", ".mental-and-motional-quiz .button-wrap .next .btn",function(){
    debugger;
    var new_url = custom.arrayValue.toLowerCase();
    console.log("new_url", new_url);
    $(".result-value").text(new_url);
    var targetUrl = $(`[data-collection="${new_url}"]`).val();
    window.location.href = targetUrl;
	});
}

custom.contactFormNextStep = function(){
  $('#first_name_wrap #first_name').bind("keyup", function () {
    if($(this).val() != ''){ 
      $(this).closest(".first_name_wrap").find(".button").removeClass("disable");
    } else {
      $(this).closest(".first_name_wrap").find(".button").addClass("disable");
    }
  });
  $('.form_wrap .email, .form_wrap .phone').bind("keyup", function () {
    if($(this).val() != ''){ 
      $(this).closest(".form_wrap").find(".button").removeClass("disable");
    } else {
      $(this).closest(".form_wrap").find(".button").addClass("disable");
    }
  });
}

custom.questionAnswerArray = function(array){
    if(array.length == 0)
      return null;
    var modeMap = {};
    var maxEl = array[0], maxCount = 1;
    for(var i = 0; i < array.length; i++) {
      var el = array[i];
      if(modeMap[el] == null)
        modeMap[el] = 1;
      else
        modeMap[el]++;  
      if(modeMap[el] > maxCount) {
        maxEl = el;
        maxCount = modeMap[el];
      }
    }
    custom.arrayValue = maxEl; 
    return maxEl;
}

custom.formRadioChangeEvent = function(){
  var selectedValurArray = [];
  $('.block-outer-wrapper .select-que-ans [type="radio"]').on('change', function() {
    selectedValurArray.push($(this).val());    
    custom.questionAnswerArray(selectedValurArray);
    console.log('selectedValurArray',selectedValurArray);
  });
};

custom.init = function() {
  custom.contactFormNextStep();
  custom.clickEvent();
  // custom.registerFormSubmit();
}

$(document).ready(function(){
  custom.init();
  custom.formRadioChangeEvent();
  $(window).load(function(){
    $('.block-outer-wrapper .select-que-ans [type="radio"]').removeAttr('checked');
    $('input[type="radio"]').prop('checked', false);
  })
})